const FndUserLovFields = [
    {
        name: '姓名',
        code: 'displayName',
        column: true,
        defaultFilter: true
    },
    {
        name: '账号',
        code: 'uid',
        column: true,
        defaultFilter: true
    },
    {
        name: '邮箱',
        code: 'email',
        align: 'center',
        defaultFilter: true
    },
    {
        name: '手机号',
        code: 'phone',
        align: 'center',
        defaultFilter: true
    }
]
export default FndUserLovFields;